<template>
  <div class="step padding-top-ml">
    <div class="content">
      <div class="ri-medium-bold-headline">
        איך קוראים לך?
      </div>

      <div class="margin-top-l">
        <text-input
          :label-text="'שם פרטי'"
          :value="firstName"
          :on-input="signupStore.setFirstName"
          :error="false"
        />
        <text-input
          class="margin-top-l"
          :label-text="'שם משפחה'"
          :value="lastName"
          :on-input="signupStore.setLastName"
          :error="false"
        />
      </div>
      <riseup-button
        class="next-button margin-top-m"
        :disabled="disabled"
        :title="'אפשר להמשיך'"
        size="small"
        :action="nextClicked"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>

import _ from 'lodash';
import TextInput from '@riseupil/base-ui/src/components/Inputs/TextInput.vue';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import RiseupButton from '@riseupil/base-ui/src/components/RiseupButton/RiseupButton.vue';
import SwitchToLogin from './SwitchToLogin.vue';
import { useSignupStore } from '../../../stores/signup';
import Segment from '../../../Segment';

const signupStore = useSignupStore();
const { firstName, lastName } = storeToRefs(signupStore);

const disabled = computed(() => _.trim(firstName.value).length < 2 || _.trim(lastName.value).length < 2);
Segment.trackUserGot('Signup_EnterName_Shown');

function nextClicked() {
  Segment.trackUserInteraction('Signup_EnterName_NextClicked', { firstName: firstName.value, lastName: lastName.value });
  signupStore.nextStep();
}

</script>
<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/mixins';

.step {
  @include white-page-frame;
  @include responsive-padding;
  flex: 1;
  width: 100%;

  .content {
    width: 100%;

    .next-button {
      height: 58px;
      width: 100%;
    }
  }
}
</style>
